import { useSelector } from "react-redux";
import { Backdrop, Snackbar, Slide, SlideProps } from "@mui/material";

import Quest from "../layout/Quest";
import Layout from "../layout/Layout";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppStore } from "../../../../providers/AppStore";
import { RootStateStepper } from "../../store/stepper-slice";
import { useAuth } from "../../../../providers/AuthProvider";
import useTheme from "../../../../common/hooks/useTheme";
import SecondaryButton from "../../../../common/ui/SecondaryButton";
import PrimaryButton from "../../../../common/ui/PrimaryButton";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="down" />;
}

const BiometricQuestionnaire = () => {
  const stepper = useSelector((state: RootStateStepper) => state.stepper.step);
  const navigate = useNavigate();
  const theme = useTheme();
  const { AuthUser } = useAuth();
  const {
    ASOpenSnackBar,
    ASSetOpenSnackBar,
    ASSnackBarMessage,
    ASTypeSnackBar,
    ASHandleCloseSnackBar,
    ASSnackBarActions,
  } = useAppStore();

  useEffect(() => {
    if (AuthUser.biometrics_questionnaire_completed) {
      navigate("/platform/dashboard");
    }
  }, []);

  const getContent = (step: number) => {
    switch (step) {
      case 2:
      case 3:
        return <Quest flexType="row" />;
      case 4:
      case 5:
        return <Quest scaleType="massUnit" />;
      case 8:
        return <Quest labelDescription={true} />;
      case 9:
        return <Quest scaleType="lengthUnit" />;
      default:
        return <Quest />;
    }
  };

  return (
    <>
      <Layout>{getContent(stepper)}</Layout>

      {/* Warning/Confirmation Snackbar */}
      <Backdrop
        open={ASOpenSnackBar && ASTypeSnackBar === "warning"}
        style={{
          color: "#fff",
          zIndex: 9998,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />
      <Snackbar
        sx={{ zIndex: 9999 }}
        open={ASOpenSnackBar && ASTypeSnackBar === "warning"}
        slots={{
          transition: SlideTransition,
        }}
        key="slide-transition-warning"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "450px",
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 61 60"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.875 3.75H36.125L34.25 37.5H26.75L24.875 3.75ZM36.125 50.625C36.125 53.7316 33.6066 56.25 30.5 56.25C27.3934 56.25 24.875 53.7316 24.875 50.625C24.875 47.5184 27.3934 45 30.5 45C33.6066 45 36.125 47.5184 36.125 50.625Z"
              fill="#3B3F42"
            />
          </svg>
          <p
            style={{
              fontSize: "14px",
              fontFamily: "var(--font-Bold)",
              color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
              textAlign: "center",
              marginBottom: "0px",
            }}
          >
            {ASSnackBarMessage.title}
          </p>
          <p
            style={{
              fontSize: "12px",
              fontFamily: "var(--font-Medium)",
              color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
              textAlign: "center",
            }}
          >
            {ASSnackBarMessage.message}
          </p>
          <div style={{ display: "flex", gap: "16px", width: "100%" }}>
            <SecondaryButton
              label={"Cancel"}
              onClick={() => {
                ASSnackBarActions.onCancel?.();
                ASHandleCloseSnackBar({} as React.SyntheticEvent);
              }}
              sx={{ width: "100%" }}
            />
            <PrimaryButton
              label={"Confirm"}
              onClick={() => {
                ASSnackBarActions.onConfirm?.();
                ASHandleCloseSnackBar({} as React.SyntheticEvent);
              }}
              sx={{ width: "100%" }}
            />
          </div>
        </div>
      </Snackbar>
    </>
  );
};

export default BiometricQuestionnaire;
